export type SpanSource = 'expert' | 'spans'

export const HIGHLIGHT_SOURCE_PRIORITY: ReadonlyArray<SpanSource> = ['expert', 'spans']

export function resolveActiveSpanBlocks(input: {
  activeSpanSource?: SpanSource
  expertBlocks: Set<string>
  spanBlocks: Set<string>
}): Set<string> {
  if (input.activeSpanSource === 'expert') {
    return input.expertBlocks
  }
  if (input.activeSpanSource === 'spans') {
    return input.spanBlocks
  }

  for (const source of HIGHLIGHT_SOURCE_PRIORITY) {
    if (source === 'expert' && input.expertBlocks.size > 0) {
      return input.expertBlocks
    }
    if (source === 'spans' && input.spanBlocks.size > 0) {
      return input.spanBlocks
    }
  }

  return new Set<string>()
}
